<ng-template #brandLogoTemplate>
  <div ddlogo class="ddlogo cursor-pointer">
    <div class="flex gap-3 align-items-center">
      @if (_auth.appConfig().brandLogoURL && _auth.appConfig().loginDefaultBrand
      === 'brandLogoURL') {
      <div class="inline-flex">
        <img
          [src]="_auth.appConfig().brandLogoURL"
          alt="logo"
          class="logo"
          [style]="{
            height: _auth.appConfig().brandLogoHeightNav
              ? _auth.appConfig().brandLogoHeightNav + 'rem'
              : '3rem'
          }"
        />
      </div>
      }@else if(_auth.appConfig().brandName &&
      _auth.appConfig().loginDefaultBrand === 'brandName') {
      <div class="dd-text" [style]="_auth.appConfig().brandNameStyle">
        {{ _auth.appConfig().brandName }}
      </div>
      }@else {
      <div class="flex align-items-center">
        <div>
          <img
            [src]="_auth.appConfig().brandLogoURL"
            alt="logo"
            class="logo"
            [style]="{
              height: _auth.appConfig().brandLogoHeightNav
                ? _auth.appConfig().brandLogoHeightNav + 'rem'
                : '3rem'
            }"
          />
        </div>
        <div class="dd-text" [style]="_auth.appConfig().brandNameStyle">
          {{ _auth.appConfig().brandName }}
        </div>
      </div>
      }
    </div>
  </div>
</ng-template>

<div app-ddtopnav>
  <div ddlogo routerLink="/" class="cursor-pointer">
    <ng-container  *ngTemplateOutlet="brandLogoTemplate"></ng-container>
  </div>
  <div app-ddtopnavlinks ddlinks [links]="links"></div>
  <div ddactions class="dd-action-container">
    <!-- For Project Selection -->
    <div class="project-select">
      <div class="project-menu-button" (click)="showProjectSwitchDialog = true">
        <p-button
          styleClass="bg-white text-black-alpha-90 h-3rem"
          raised="true"
          [rounded]="true"
          [text]="true"
          [plain]="true"
        >
          @if (currentProject && currentProject?.themeSettings &&
          currentProject?.themeSettings.logoURL) {
          <img
            [src]="currentProject.themeSettings.logoURL"
            [alt]="currentProject?.name"
            class="project-btn-logo"
            [ngClass]="isImageLoaded ? '' : 'hidden'"
            (load)="handleImageLoad()"
          />
          @if (!isImageLoaded) {
          <p-skeleton
            width="8rem"
            height="2rem"
            borderRadius="1rem"
          ></p-skeleton>
          } } @else if (currentProject && currentProject?.name) {
          <span [style.fontSize]="'0.85rem'">{{ currentProject.name }}</span>
          }@else { @if(isFetchingDetails){
          <i class="pi pi-spin pi-spinner mr-2" style="font-size: 1.2rem"></i>
          }
          <span class="text-base">Select Project</span>
          }
          <i class="pi pi-chevron-down ml-2"></i>
        </p-button>
      </div>
    </div>

    <div class="dd-right-side-actions">

      <p-button
        styleClass="text-gray-800 mr-1"
        icon="pi"
        [rounded]="true"
        text="true"
        [plain]="true"
        pTooltip="Requests"
        tooltipPosition="bottom"
        (click)="handleRequests()"
      >
        <span class="material-symbols-outlined"> schedule </span>
      </p-button>

      <p-button
        styleClass="text-gray-800 mr-1"
        icon="pi"
        [rounded]="true"
        text="true"
        [plain]="true"
        pTooltip="Notifications"
        tooltipPosition="bottom"
        (click)="handleNotifications()"
      >
        @if(newNotifications.length) {
        <p-badge
          class="dd-notifications-badge"
          severity="danger"
          [value]="newNotifications.length"
          styleClass="absolute "
        ></p-badge>
        }
        <!-- <img src="assets/svg/icons/notifications.svg" class="material-symbols-outlined" /> -->
        <svg-icon color="#424242" size="2xl" key="notifications"></svg-icon>
      </p-button>
      <!-- <p-button
        styleClass="text-gray-800"
        icon="pi"
        [rounded]="true"
        text="true"
        [plain]="true"
        (onClick)="switchMode()"
      >
        @if (mode == 'light') {
        <i class="pi pi-moon"></i>
        }@else {
        <i class="pi pi-sun"></i>
        }
      </p-button> -->
      <!-- <p-button [rounded]="true" text="true" [plain]="true" (onClick)="openProductHub()" pTooltip="Product Hub" tooltipPosition="bottom" >
        <svg
          width="22"
          height="20"
          viewBox="0 0 22 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13 2.56689H2C1.53587 2.56689 1.09075 2.75127 0.762563 3.07946C0.434374 3.40765 0.25 3.85277 0.25 4.31689V14.3169C0.25 15.2829 1.034 16.0669 2 16.0669H6.689L9.47 18.8469C9.53957 18.9166 9.62218 18.9718 9.71312 19.0095C9.80407 19.0472 9.90155 19.0666 10 19.0666C10.0984 19.0666 10.1959 19.0472 10.2869 19.0095C10.3778 18.9718 10.4604 18.9166 10.53 18.8469L13.311 16.0669H18C18.4641 16.0669 18.9092 15.8825 19.2374 15.5543C19.5656 15.2261 19.75 14.781 19.75 14.3169V9.31689C19.75 9.11798 19.671 8.92722 19.5303 8.78656C19.3897 8.64591 19.1989 8.56689 19 8.56689C18.8011 8.56689 18.6103 8.64591 18.4697 8.78656C18.329 8.92722 18.25 9.11798 18.25 9.31689V14.3169C18.25 14.3832 18.2237 14.4468 18.1768 14.4937C18.1299 14.5406 18.0663 14.5669 18 14.5669H13C12.9015 14.5668 12.804 14.5862 12.713 14.624C12.6221 14.6617 12.5395 14.7171 12.47 14.7869L10 17.2559L7.53 14.7869C7.46052 14.7171 7.37793 14.6617 7.28697 14.624C7.19601 14.5862 7.09848 14.5668 7 14.5669H2C1.9337 14.5669 1.87011 14.5406 1.82322 14.4937C1.77634 14.4468 1.75 14.3832 1.75 14.3169V4.31689C1.75 4.25059 1.77634 4.187 1.82322 4.14012C1.87011 4.09323 1.9337 4.06689 2 4.06689H13C13.1989 4.06689 13.3897 3.98788 13.5303 3.84722C13.671 3.70657 13.75 3.51581 13.75 3.31689C13.75 3.11798 13.671 2.92722 13.5303 2.78656C13.3897 2.64591 13.1989 2.56689 13 2.56689Z"
            fill="var(--gray-800)"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.0549 1.44788L11.2739 8.22988C11.2023 8.3008 11.1458 8.38551 11.1079 8.47888L9.67287 12.0359C9.61736 12.1723 9.60334 12.3222 9.63254 12.4666C9.66174 12.6109 9.73288 12.7435 9.83705 12.8477C9.94122 12.9519 10.0738 13.023 10.2182 13.0522C10.3626 13.0814 10.5124 13.0674 10.6489 13.0119L14.2059 11.5769C14.2992 11.5387 14.3841 11.4827 14.4559 11.4119L21.2369 4.62988C21.3996 4.46751 21.5288 4.27463 21.6169 4.06228C21.705 3.84993 21.7503 3.62229 21.7503 3.39238C21.7503 3.16248 21.705 2.93484 21.6169 2.72249C21.5288 2.51014 21.3996 2.31725 21.2369 2.15488L20.5299 1.44788C20.3676 1.28488 20.1748 1.15554 19.9624 1.06728C19.7501 0.979027 19.5223 0.933594 19.2924 0.933594C19.0624 0.933594 18.8347 0.979027 18.6223 1.06728C18.4099 1.15554 18.2171 1.28488 18.0549 1.44788ZM19.1159 2.50788C19.1391 2.4846 19.1667 2.46613 19.1971 2.45353C19.2274 2.44092 19.26 2.43444 19.2929 2.43444C19.3258 2.43444 19.3583 2.44092 19.3887 2.45353C19.4191 2.46613 19.4466 2.4846 19.4699 2.50788L20.1769 3.21488C20.2002 3.23811 20.2186 3.26569 20.2312 3.29607C20.2438 3.32644 20.2503 3.359 20.2503 3.39188C20.2503 3.42477 20.2438 3.45733 20.2312 3.4877C20.2186 3.51807 20.2002 3.54566 20.1769 3.56888L13.5029 10.2429L11.7239 10.9609L12.4419 9.18188L19.1159 2.50788Z"
            fill="var(--gray-800)"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.4701 4.09405L18.5911 6.21505C18.7324 6.35173 18.9219 6.42742 19.1185 6.4258C19.3152 6.42419 19.5033 6.3454 19.6424 6.20641C19.7816 6.06742 19.8605 5.87934 19.8623 5.6827C19.8641 5.48605 19.7886 5.29656 19.6521 5.15505L17.5301 3.03305C17.3885 2.89649 17.1991 2.82098 17.0024 2.82279C16.8058 2.82459 16.6177 2.90355 16.4787 3.04267C16.3397 3.1818 16.2609 3.36994 16.2593 3.56659C16.2577 3.76324 16.3334 3.95266 16.4701 4.09405Z"
            fill="var(--gray-800)"
          />
        </svg>
      </p-button> -->
      <p-button
        styleClass="text-gray-800"
        icon="pi"
        [rounded]="true"
        text="true"
        [plain]="true"
        (onClick)="openSettings()"
        pTooltip="Setting"
        tooltipPosition="bottom"
        class="mr-4"
      >
        <svg-icon color="#424242" size="2xl" key="settings"></svg-icon>
      </p-button>
      <p-button
        styleClass="text-gray-800 h-3rem"
        pRipple
        [text]="true"
        [outlined]="true"
        [rounded]="true"
        [plain]="true"
        (click)="menu.toggle($event)"
      >
        @if (userImageUrl.length < 1) {
        <svg-icon
          color="#424242"
          size="4xl"
          [noShrink]="false"
          key="account-circle"
        ></svg-icon>
        }@else {
        <p-avatar [image]="userImageUrl" class="mr-2" shape="circle" />
        }
        <span
          class="inline-flex flex-column ml-2 justify-content-start align-items-start max-w-7rem overflow-hidden white-space-nowrap text-overflow-ellipsis"
        >
          @if (_auth.userDetail().firstName || _auth.userDetail().lastName ||
          _auth.userDetail().email) {
          <span
            class="font-bold max-w-7rem overflow-hidden white-space-nowrap text-overflow-ellipsis"
          >
            {{
              _auth.userDetail().firstName
                ? _auth.userDetail().firstName[0].toUpperCase() +
                  _auth.userDetail().firstName.slice(1)
                : _auth.userDetail().lastName
                ? _auth.userDetail().lastName[0].toUpperCase() +
                  _auth.userDetail().lastName.slice(1)
                : _auth.userDetail().email
            }}
          </span>
          <span class="text-sm font-normal">{{ _auth.userDetail().role }}</span>
          }@else {
          <i class="pi pi-spin pi-spinner" style="font-size: 1.2rem"></i>
          }
        </span>
        <i
          class="pi pi-angle-down"
          style="font-size: 1rem; margin-left: 0.5rem"
        ></i>
      </p-button>
      <div class="card flex justify-content-center">
        <p-menu
          #menu
          [model]="profileItems"
          [popup]="true"
          styleClass="w-full md:w-15rem"
          appendTo="body"
        >
          <ng-template pTemplate="submenuheader" let-item>
            <span class="text-primary font-bold">{{ item.label }}</span>
          </ng-template>
          <ng-template pTemplate="item" let-item>
            <a pRipple class="flex align-items-center p-menuitem-link">
              <span [class]="item.icon"></span>
              <span class="ml-2">{{ item.label }}</span>
            </a>
          </ng-template>
          <ng-template pTemplate="end">
            <button
              pRipple
              class="relative overflow-hidden w-full p-link flex align-items-center p-2 pl-3 text-color hover:surface-200 border-noround"
            >
              @if (userImageUrl.length < 1) {
              <svg-icon
                color="#424242"
                size="4xl"
                [noShrink]="true"
                key="account-circle-bold"
              ></svg-icon>
              }@else {
              <p-avatar [image]="userImageUrl" class="mr-2" shape="circle" />
              }
              <span class="inline-flex flex-column ml-2" style="max-width: 80%">
                @if (_auth.userDetail().firstName || _auth.userDetail().lastName
                || _auth.userDetail().email) {
                <span
                  class="font-bold text-overflow-ellipsis overflow-hidden whitespace-nowrap"
                >
                  {{
                    _auth.userDetail().firstName
                      ? _auth.userDetail().firstName[0].toUpperCase() +
                        _auth.userDetail().firstName.slice(1)
                      : _auth.userDetail().lastName
                      ? _auth.userDetail().lastName[0].toUpperCase() +
                        _auth.userDetail().lastName.slice(1)
                      : _auth.userDetail().email
                  }}
                </span>
                <span class="text-sm">{{ _auth.userDetail().role }}</span>
                }@else {
                <i class="pi pi-spin pi-spinner" style="font-size: 1.2rem"></i>
                }
              </span>
            </button>
          </ng-template>
        </p-menu>
      </div>
    </div>
  </div>
</div>

<p-dialog
  [draggable]="false"
  [(visible)]="notificationService.isNotificationDialogVisible"
  [style]="{
    position: 'absolute',
    top: '4.5rem',
    right: '0rem',
    width: '35rem',
    'max-height': 'calc(100vh - 5.5rem)',
    'background-color': 'var(--surface-0)'
  }"
  [dismissableMask]="true"
  [closable]="true"
  position="right"
  class="notifications-dialog"
  [styleClass]="
    'p-3 border-round-xl ' + (isAllNotificationsVisible ? 'pb-6' : '')
  "
  (onHide)="handleDialogClose()"
>
  <ng-template pTemplate="header">
    <div
      class="notif-header font-medium test-sm w-full flex justify-content-between align-items-center mr-2"
    >
      <div>Notifications</div>

      <div class="flex align-items-center gap-2">
        @if(!isAllNotificationsVisible) {
        <div
          class="text-xs font-medium underline text-primary cursor-pointer"
          (click)="handleShowAllNotifications()"
        >
          All notifications
        </div>
        } @else {

        <p-selectButton
          [options]="notificationOptions"
          [(ngModel)]="selectedNotificationOption"
          optionLabel="label"
          [allowEmpty]="false"
        />

        <p-dropdown
          [options]="contextOptions"
          [(ngModel)]="selectedContext"
          optionLabel="label"
          placeholder="category"
          styleClass="text-xs w-fit-content"
          [showClear]="true"
          appendTo="body"
          panelStyleClass="text-xs w-fit-content"
        />
        }
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="content">
    <app-notification
      [newNotifications]="newNotifications"
      [isAllNotificationsVisible]="isAllNotificationsVisible"
      [selectedContext]="(selectedContext && selectedContext.value) || 'all'"
      [selectedNotificationOption]="selectedNotificationOption.value"
    />
  </ng-template>
</p-dialog>

<!-- Project Switch Dialog -->
<p-dialog
  [(visible)]="showProjectSwitchDialog"
  [modal]="true"
  [dismissableMask]="true"
  [closable]="true"
  [draggable]="false"
  header="Select Project"
  [style]="{ width: '32rem', 'max-height': '80vh' }"
  styleClass="project-switch-dialog border-round-xl"
  appendTo="body">
  <div class="select-project-container flex flex-column py-2">
    @if(isFetchingDetails) {
      <div class="spinner flex justify-content-center py-4">
        <svg viewBox="25 25 50 50">
          <circle r="20" cy="50" cx="50"></circle>
        </svg>
      </div>
    } @else if(tenantItems.length === 0) {
      <div class="flex gap-2 align-items-center text-xs border-1 border-gray-400 p-3 border-round-lg shadow-1">
        <span class="material-symbols-outlined text-yellow-500 text-5xl">warning</span>
        <div class="flex flex-column text-xs justify-content-center">
          <div class="font-bold">No project found</div>
          <div class="text-gray-600">Please reach out to your admin to request access</div>
        </div>
      </div>
    } @else {
      <div class="project-grid">
        @for (item of tenantItems; track item.label) {
          <div
            class="project-card flex flex-column align-items-center justify-content-center gap-2 p-3 border-round-lg cursor-pointer"
            [class.selected]="currentProject?.name === item.label"
            (click)="changeProject(item.label)">
            @if (item.logo) {
              <div class="project-card-image flex align-items-center justify-content-center">
                <img [src]="item.logo" [alt]="item.label" class="project-logo" />
              </div>
            } @else {
              <div class="project-card-image flex align-items-center justify-content-center">
                <span class="project-initials text-primary-600 font-bold text-xl">
                  {{ item.label.slice(0, 2).toUpperCase() }}
                </span>
              </div>
              <span class="text-xs font-medium text-center w-full text-overflow-ellipsis overflow-hidden white-space-nowrap" pTooltip="{{ item.label }}" tooltipPosition="bottom">
                {{ item.label }}
              </span>
            }
            @if (currentProject?.name === item.label) {
              <span class="text-xs text-primary-500 font-semibold">Current</span>
            }
          </div>
        }
      </div>
    }
  </div>
</p-dialog>

<!-- First-time Project Selection Dialog -->
<p-dialog
  [(visible)]="showProjectSelectionDialog"
  [modal]="true"
  [baseZIndex]="10000"
  [closable]="false"
  [showHeader]="false"
  [style]="{position : 'absolute', top : '6rem', 'width' : '30rem'}"
  styleClass="border-round-lg overflow-hidden surface-0 p-3 px-4 "
  appendTo="body">
        <div class="select-project-container flex align-items-center justify-content-center flex-column py-3">
            <ng-container *ngTemplateOutlet="brandLogoTemplate"></ng-container>
            <div class="text-2xl font-bold mt-3 mb-1">Lets get started</div>
            <div class="text-xs text-gray-500">Choose the project you would like to explore</div>

            <div class="flex align-items-center gap-2 mt-4 mb-2 font-bold text-sm align-self-start">
              <span class="material-symbols-outlined text-sm">
                corporate_fare
              </span>
              <div>Select project</div>
            </div>

            <div class="projects-list flex flex-column w-full pr-2 pt-1">
              @if(isFetchingDetails) {
                <div class="spinner flex justify-content-center">
                  <svg viewBox="25 25 50 50">
                    <circle r="20" cy="50" cx="50"></circle>
                  </svg>
                </div>
              }
              @else if(tenantItems.length === 0) {
                <div class="flex gap-2 align-items-center text-xs border-1 border-gray-400 p-3 border-round-lg shadow-1">
                  <span class="material-symbols-outlined text-yellow-500 text-5xl">
                    warning
                  </span>

                  <div class="flex flex-column text-xs justify-content-center">
                      <div class="font-bold">No project found</div>
                      <div class="text-gray-600">Please reach out to your admin to request access</div>
                  </div>
                </div>
              } @else {
                <p-dropdown
                  [options]="tenantItems"
                  [(ngModel)]="dropdownSelect"
                  optionLabel="label"
                  (onChange)="updateSelectedProject()"
                  placeholder="Select a project to get started"
                  appendTo="body"
                  styleClass="w-full text-xs p-2"
                  panelStyleClass="custom-dropdown-panel"
                />
              }
            </div>

            @if(tenantItems.length > 0) {
              <p-button styleClass="py-2 px-4 mt-3" [disabled]="!this.selectedProject">
                <span
                  class="font-normal text-sm mr-1"
                  (click)="getStarted()"
                >
                  Get Started
                </span>
                <span class="material-symbols-outlined">
                  arrow_right_alt
                </span>
              </p-button>
            }
        </div>
</p-dialog>
